import { render, staticRenderFns } from "./AnnotationComponent.vue?vue&type=template&id=7cfa5102&scoped=true&"
import script from "./AnnotationComponent.vue?vue&type=script&lang=js&"
export * from "./AnnotationComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationComponent.vue?vue&type=style&index=0&id=7cfa5102&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa5102",
  null
  
)

export default component.exports